import styled from "styled-components";
import { V3Body } from "../Typography";

export const V3BodyGrey48 = styled(V3Body)`
    color: ${({ theme }) => theme.v3.colors.grey48};
`;